import axiosClient from '../axiosClient';

export const getChatRooms = (params) =>
  axiosClient.get('/admin/chat/rooms', { params });

export const getChatMessages = (roomId, params) =>
  axiosClient.get(`/admin/chat/rooms/${roomId}/messages`, { params });

export const getLiveStreams = (params) =>
  axiosClient.get('/admin/live-streams', { params });

export const getLiveStreamDetail = (id) =>
  axiosClient.get(`/admin/live-streams/${id}`);

export const updateStreamStatus = (id, status) =>
  axiosClient.patch(`/admin/live-streams/${id}/status`, { status });
